/* eslint-disable no-underscore-dangle */

import Renderer from './boolean-renderer';

const EventEmitter = require('events');

class BooleanComponent extends EventEmitter {
  constructor(value) {
    super();
    this._value = value;
    this._renderer = new Renderer(this);
    this._registerListeners();
  }

  /* ***************************************** */
  /* START PRIVATE COMPONENT MODEL METHODS     */
  /* ***************************************** */

  _registerListeners() {}

  _unregisterListeners() {}

  /* ***************************************** */
  /* END PRIVATE COMPONENT MODEL METHODS       */
  /* START PUBLIC COMPONENT MODEL METHODS      */
  /* ***************************************** */

  get renderer() {
    return this.getRenderer();
  }

  getRenderer() {
    return this._renderer;
  }

  shutdown() {
    this._unregisterListeners();
    const prom = this._renderer._shutdown();
    this._renderer = undefined;
    return prom;
  }

  /* ***************************************** */
  /* END COMPONENT MODEL METHODS               */
  /* START HANDLER METHODS                     */
  /* ***************************************** */

  /* ***************************************** */
  /* END HANDLER METHODS                       */
  /* START PRIVATE METHODS                     */
  /* ***************************************** */

  /* ***************************************** */
  /* END PRIVATE METHODS                       */
  /* START PUBLIC API METHODS                  */
  /* ***************************************** */

  setValue() {
    this.emit('Update', this._value);
  }

  getValue() {
    return this._value;
  }

  /* ***************************************** */
  /* END PUBLIC API METHODS                    */
  /* ***************************************** */
}

export default BooleanComponent;
